module.exports = __webpack_public_path__ + "img/introduce-1.e4fa9c1c.png";